import { ComponentConfig } from "@measured/puck";

import { SupersetChartBlock, SupersetChartBlockProps } from "./SupersetChartBlock";

export type { SupersetChartBlockProps } from "./SupersetChartBlock";

export const SupersetChart: ComponentConfig<SupersetChartBlockProps> = {
    label: "Superset Chart",
    fields: {
        title: {
            type: "text",
            label: "Title",
        },
        src: {
            type: "text",
            label: "Chart URL",
        },
        height: {
            type: "number",
            label: "Chart height (in px)",
        },
        hideWhenEmpty: {
            type: "select",
            label: "Hide when the chart has no data",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
    },
    defaultProps: {
        title: "",
        src: "",
        height: 400,
        hideWhenEmpty: false,
    },
    render: ({ puck, ...props }) => <SupersetChartBlock {...props} isEditing={puck.isEditing} />,
};

export default SupersetChart;
